import styles from '../../styles/FormHeader.module.scss';

export const FormHeader = () => {
    return (
        <>
            <section className={styles.formTitle}>
                <div className={styles.formItems}>
                    <h1>¡Hola! Vamos a iniciar con la solicitud</h1>
                    <p>Necesitamos unos datos antes de comenzar</p>
                </div>
            </section>
        </>
    );
};

export const FormHeaderFinished = () => {
    return (
        <>
            <section className={styles.formTitle}>
                <div className={styles.formItems}>
                    <h1>¡Gracias por completar el formulario!</h1>
                    <p style={{ fontSize: 18 }}>
                        Comunícate con tu asesor para continuar con el proceso.
                    </p>
                </div>
            </section>
        </>
    );
};
